import React, { Component, ErrorInfo } from 'react';
import * as Sentry from '@sentry/browser';
import { Button, Modal } from 'antd';

import { ErrorBoundaryProps, ErrorBoundaryState } from './ErrorBoundary.types';

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (process.env.REACT_APP_SENTRY_DSN) {
      Sentry.withScope((scope) => {
        scope.setExtras({ errorInfo });
        Sentry.captureException(error);
      });
    }
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Modal
          visible={true}
          onOk={() => {}}
          title={'Oops'}
          footer={[
            <Button
              key="reload"
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload page
            </Button>,
          ]}
        >
          <p>{"We're sorry, but something went wrong. Refresh the page and try again."}</p>
        </Modal>
      );
    }

    return children;
  }
}
